import createReactComponent from '../createReactComponent';
var Highlighter = createReactComponent('Highlighter', [['path', {
  d: 'M9 11l-6 6v3h9l3-3',
  key: 'je37i2'
}], ['path', {
  d: 'M22 12l-4.6 4.6a2 2 0 01-2.8 0l-5.2-5.2a2 2 0 010-2.8L14 4',
  key: '17ayc1'
}]]);
export default Highlighter;